import { gql } from "apollo-angular";

const PRODUCT_EDIT= gql`
          mutation productEdit($productId: Long!, $changes: [SingleProductChange!]!){
            productEdit(
                productEditRequest: {
                    productId: $productId
                    changes: $changes
                }
            ) {
                success
            }
          }
        `;
        
export default PRODUCT_EDIT;